import Route from '@ember/routing/route'
import { service } from '@ember/service'
import RSVP from 'rsvp'
import type { StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type ReportingUiScopeRoute from 'teacher-ui-client/reporting/ui-scope/route'
import type RexStudentSummaryRoute from 'teacher-ui-client/reporting/ui-scope/rex/student-summary/route'
import type { NormalizedInterval } from 'date-fns'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export default class extends Route {
  @service studentEvents!: StudentEventsService

  async model() {
    const { scopedData, period } = this.modelFor('reporting.ui-scope') as ModelFor<ReportingUiScopeRoute>
    const { student } = this.modelFor('reporting.ui-scope.rex.student-summary') as ModelFor<RexStudentSummaryRoute>

    const statsScope: StudentsScope = { scope: 'students', ids: [student.id] }

    const product: LegacyProductRex = 'rex'
    const stats = await this.makeStatsRequests(product, statsScope, period)

    return {
      product,
      period,
      student,
      students: scopedData.students,
      ...stats,
    }
  }

  makeStatsRequests(product: LegacyProductRex, scope: StudentsScope, period: NormalizedInterval) {
    const { studentEvents } = this
    return RSVP.hash({
      courseProgressComprehension: studentEvents.courseProgressLessonsStudent(product, 'my_lessons', scope, period),
      courseProgressSpelling: studentEvents.courseProgressSpellingStudent(product, 'spelling', scope, period),
      stadiumEventsStudent: studentEvents.stadiumEventsStudent(product, scope, period),
      booksReadStudent: studentEvents.booksReadStudent(product, scope, period),
      lexileDetailsStudent: studentEvents.lexileDetailsStudent(product, scope, period),
      assessmentScoresStudent: studentEvents.assessmentScoresByGenreStudent(product, scope, period),
      quizScoresStudent: studentEvents.quizScoresStudent(product, scope, period),
    })
  }
}
